import { formatMoney, addRecentItemToLocalStorage } from '../functions';

export default () => {
  const el = document.querySelector('[data-pdp]');

  if (el) {
    let quantity = 1;
    let currentVariant = null;

    const pageData = {
      product: JSON.parse(document.getElementById('json-product').innerHTML),
      currentVariant: JSON.parse(document.getElementById('json-current-variant').innerHTML),
      variants: JSON.parse(document.getElementById('json-variants').innerHTML),
      dimensions: JSON.parse(document.getElementById('json-product-dimensions').innerHTML),
      shippingRegion: document.querySelector('.layout-pdp') ? document.querySelector('.layout-pdp').dataset.shippingRegion : null,
    };

    const els = {
      select: document.querySelector('[data-pdp-select]'),
      quantityInput: document.querySelector('[data-pdp-quantity-input]'),
      addBtn: document.querySelector('[data-pdp-add]'),
      subtractBtn: document.querySelector('[data-pdp-subtract]'),
      price: document.querySelector('[data-pdp-price]'),
      quantity: document.querySelector('[data-pdp-quantity]'),
      variantInput: document.querySelector('[data-pdp-variant-input]'),
      variantName: document.querySelector('[data-pdp-variant-name]'),
      variantDropdown: document.querySelector('[data-pdp-variant-dropdown]'),
      variantDropdownItem: document.querySelectorAll('[data-pdp-variant-dropdown-item]'),
      variantDropdownToggle: document.querySelectorAll('[data-pdp-variant-dropdown-toggle]'),
      propertyInputs: document.querySelectorAll('[data-pdp-properties]'),
      measurementsData: document.querySelector('.layout-pdp__content .product-f-measurements'),
    };

    const classes = {
      variantDropdownOpen: 'layout-pdp__variant-dropdown--open',
    };

    // functions
    const getVariant = (id) => pageData.variants.find((variant) => variant.id === id.toString());

    const updatePrice = () => {
      // eslint-disable-next-line quotes
      els.price.innerHTML = currentVariant.comparePrice !== "" ? `<s>${Shopify.currency.active + " " + formatMoney(currentVariant.comparePrice * quantity)}</s> ${Shopify.currency.active + " " + formatMoney(currentVariant.priceCents * quantity)}` : `${Shopify.currency.active + " " + formatMoney(currentVariant.priceCents * quantity)}`;
    };

    const updateQuantity = (quantity) => {
      els.quantity.innerHTML = quantity;
      els.quantityInput.value = quantity;
    };

    // event handlers
    const setVariant = (id, newVariantTitle) => {
      const newVariant = getVariant(id);
      currentVariant = newVariant;

      updatePrice();
      els.variantName.innerHTML = newVariantTitle;
      els.variantInput.value = currentVariant.id;
      window.history.replaceState(null, null, `?variant=${newVariant.id}`);
    };

    const convertDimensions = (measurementsEl, optionsEl, optionIndex) => {
      const data = measurementsEl.querySelector('.product-f-measurements__dimensions.active').innerText;
      if (!data) return;

      optionsEl.forEach((opt) => {
        const oldVariantTitle = opt.innerText;
        if (!oldVariantTitle.includes(' / ')) return;

        let newVariantTitle = oldVariantTitle;

        if (data.includes(':')) {
          // Replace using key-value pair
          let isTitleReplaced = false;

          data
            .split(',')
            .forEach((metaItem) => {
              if (isTitleReplaced) return;

              const metaKeyValuePair = metaItem.split(':');

              if (metaKeyValuePair[1] && metaKeyValuePair[1].toLowerCase() !== 'null' && metaKeyValuePair[1].toLowerCase() !== 'n/a' && metaKeyValuePair[0] !== metaKeyValuePair[1]) {
                if (metaKeyValuePair[0].includes(' x ')) {
                  newVariantTitle = newVariantTitle.replaceAll(metaKeyValuePair[0], metaKeyValuePair[1]);
                } else {
                  newVariantTitle = newVariantTitle.replaceAll(metaKeyValuePair[0], metaItem.replace(':', ' '));
                }

                if (oldVariantTitle !== newVariantTitle) {
                  isTitleReplaced = true;
                }
              }
            });
        } else if (optionIndex > -1) {
          // Replace using option index
          const variantOptionVals = oldVariantTitle.split(' / ');
          variantOptionVals[optionIndex] = data;
          newVariantTitle = variantOptionVals.join(' / ');
        }

        if (oldVariantTitle !== newVariantTitle) {
          opt.innerText = newVariantTitle;
        }
      });
    };

    const init = () => {
      if (els.measurementsData) {
        const optionLabels = els.measurementsData.dataset.optionLabels ? JSON.parse(els.measurementsData.dataset.optionLabels).map((opt) => opt.toLowerCase()) : [];
        const sizeOptIndex = optionLabels.indexOf('size');
        if (els.measurementsData.classList.contains('render-complete')) {
          convertDimensions(els.measurementsData, [els.variantName, ...els.variantDropdownItem], sizeOptIndex);
        } else {
          els.measurementsData.addEventListener('pfm:render', () => {
            convertDimensions(els.measurementsData, [els.variantName, ...els.variantDropdownItem], sizeOptIndex);
          });
        }
      }
      initLineItemProps();
      currentVariant = getVariant(pageData.currentVariant.id);
      if (els.variantDropdown) els.variantDropdown.style.height = '0';
      addRecentItemToLocalStorage({
        handle: pageData.product.handle,
        measurements: pageData.dimensions,
        shippingRegion: pageData.shippingRegion,
      });
      els.variantInput.value = currentVariant.id;
    };

    const initLineItemProps = () => {
      const propertiesInput = document.getElementById('gift-card-properties');
      if (!propertiesInput && !els.propertyInputs) return;

      const lineItemProps = {};

      els.propertyInputs.forEach((input) => {
        input.addEventListener('change', ({ target }) => {
          const inputName = target ? target.name : '';
          const lineItemKey = inputName ? inputName.replace('properties[', '').replace(']', '') : '';
          lineItemProps[lineItemKey] = target.value;
          propertiesInput.value = input.value !== '' ? JSON.stringify(lineItemProps) : '{}';
        });
      });
    };

    const openOptionsDropdown = () => {
      els.variantDropdown.setAttribute('aria-expanded', true);
      els.variantDropdown.style.display = 'block';
      els.variantDropdown.style.transition = 'height .3s';

      const contentHeight = els.variantDropdown.scrollHeight;
      els.variantDropdown.style.height = `${contentHeight}px`;
    };

    const closeOptionsDropdown = () => {
      els.variantDropdown.setAttribute('aria-expanded', false);

      const contentHeight = els.variantDropdown.scrollHeight;
      els.variantDropdown.classList.remove(classes.variantDropdownOpen);

      els.variantDropdown.style.height = `${contentHeight}px`;
      els.variantDropdown.style.transition = 'height .3s';

      window.requestAnimationFrame(() => {
        // “pausing” the JavaScript execution to let the rendering threads catch up
        // http://stackoverflow.com/questions/779379/why-is-settimeoutfn-0-sometimes-useful
        setTimeout(() => {
          els.variantDropdown.style.height = 0;
        }, 0);
      });
    };

    // const selectVariantFomMaterial = (optionKey, title, name, group) => {
    //   const newVariant = getVariantFomMaterial(optionKey, title);

    //   els.select.value = newVariant.id;
    //   els[`${optionKey}Group`].innerHTML = group;
    //   els[`${optionKey}Name`].innerHTML = name;
    //   els.price.innerHTML = newVariant.price;
    //   els.image.forEach(el => {
    //     el.src = newVariant.imgSrc;
    //     el.srcset = newVariant.imgSrcset;
    //     }
    //   );
    //   data.currentVariant = newVariant;

    //   history.replaceState(null, null, `?variant=${newVariant.id}`);

    // }

    // handlers
    const handlePressAdd = () => {
      quantity += 1;
      updatePrice();
      updateQuantity(quantity);
    };

    const handlePressSubtract = () => {
      if (quantity > 1) {
        quantity -= 1;
        updatePrice(quantity);
        updateQuantity(quantity);
      }
    };

    const handleSelectVariant = (e) => {
      console.log('------------', handleSelectVariant);
      const newVariantId = e.currentTarget.dataset.pdpVariantDropdownItem;
      const newVariantTitle = e.currentTarget.innerText;
      setVariant(newVariantId, newVariantTitle);
      closeOptionsDropdown();
      handleSelectedVariant();
      e.target.setAttribute('selected', true);
    };

    const handleSelectedVariant = () => {
      els.variantDropdownItem.forEach((el) => {
        el.removeAttribute('selected');
      });
    };

    const handleVariantToggleClick = () => {
      const isOpen = els.variantDropdown.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeOptionsDropdown();
      } else {
        openOptionsDropdown();
      }
    };

    const handleDropdownTransitionEnd = () => {
      const isOpen = els.variantDropdown.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        els.variantDropdown.style.height = '';
        els.variantDropdown.classList.add(classes.variantDropdownOpen);
      } else {
        els.variantDropdown.style.display = 'none';
      }
    };

    // apply event listeners
    if (els.select) {
      // els.select.addEventListener('change', handleVariantChange);
    }

    if (els.variantDropdownItem.length) {
      els.variantDropdownItem.forEach((item) => {
        item.addEventListener('click', handleSelectVariant);
      });
    }
    if (els.variantDropdownToggle.length) {
      els.variantDropdownToggle.forEach((toggle) => {
        toggle.addEventListener('click', handleVariantToggleClick);
      });
    }
    els.addBtn.addEventListener('click', handlePressAdd);
    els.subtractBtn.addEventListener('click', handlePressSubtract);

    if (els.variantDropdown) {
      els.variantDropdown.addEventListener('transitionend', handleDropdownTransitionEnd);
    }

    // init
    init();
  }
};
